module.exports = __webpack_public_path__ + "assets/Iota.4ba623c96c4fecd37fb202db107745d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Iota.png
// module id = 787
// module chunks = 0